import * as React from "react";
import * as ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import { theme } from "./styles/theme";
import App from "./App";

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <SnackbarProvider hideIconVariant>
      <CssBaseline />
      <App />
    </SnackbarProvider>
  </ThemeProvider>,
  document.getElementById("root")
);
